import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom"
import { Form, Button, Input, Select, Modal, Row, Col, Space, message } from 'antd'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import E from 'wangeditor'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 10 }
}

export default function AddSales() {

    const [response, setResponse] = useState<any[]>([])
    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [formInstance] = Form.useForm()
    const [editor, setEditor] = useState<null | E>(null)

    let { id }: { id: string } = useParams()

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo.get("/markting_center/sales/detail", {
                params: {
                    sales_id: id
                }

            }).then((res: any) => {
                setResponse(res)

                if (res.is_forbidden == null) {
                    res.is_forbidden = 1
                }

                if (res.is_new == null) {
                    res.is_new = 0
                }

                formInstance.setFieldsValue(res)
            })
        }
    }, [])

    const handleModalOk = () => {
        let html = editor?.txt.html()
        formInstance.setFieldsValue({ brand_description: html })

        setEditorVisible(false)
    }

    const onFinish = (values: any) => {
        if (!/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/.test(values.accept_multiple)) {
            message.error('接收倍数只能输入大于0的正整数，保留1位小数')
            return;
        }

        if (values.accept_multiple >= 10) {
            message.error('接收倍数不能大于等于10')
            return;
        }

        delete values.user_name
        delete values.phone
        delete values.in_date

        // 编辑
        axiosHandleEvent.post('/markting_center/sales/update', {
            id, ...values
        }).then(res => {

        })
    }

    const myStatus: any = [{ id: 0, name: '是' }, { id: 1, name: '否' }]
    const newMyStatus: any = [{ id: 1, name: '是' }, { id: 0, name: '否' }]

    return (<div className="common-level2-edit">
        {/* 营销中心 -> 销售管理 -> 销售列表 -> 编辑 */}
        <h2>{id ? '编辑' : '新增'}销售</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_editor" onFinish={onFinish}>
                <Form.Item label="员工姓名" name='user_name' rules={[{ required: true, message: '必须输入员工姓名' }]}>
                    <Input placeholder="请填写员工姓名" disabled />
                </Form.Item>

                <Form.Item label="员工手机号" name='phone' rules={[{ required: true, message: '必须输入员工手机号' }]}>
                    <Input placeholder="请填写员工手机号" disabled />
                </Form.Item>

                <Form.Item label="入职日期" name='in_date' rules={[{ required: true, message: '必须选择入职日期' }]}>
                    <Input placeholder="请选择入职日期" disabled />
                </Form.Item>

                <Form.Item label="限制客资数" name='customer_limit_num' rules={[{ required: true, message: '必须输入限制客资数' }]}>
                    <Input placeholder="请填写限制客资数" />
                </Form.Item>

                <Form.Item label="接收倍数" name="accept_multiple" rules={[{ required: true, message: '必须输入接收倍数' }]}>
                    <Input placeholder="请填写接收倍数" />
                </Form.Item>

                <Form.Item label="是否接受流失客资" name="is_new" rules={[{ required: true, message: '必须选择是否接受流失客资' }]}>
                    <Select style={{ width: 160 }} placeholder="请选择是否接受流失客资">
                        {newMyStatus.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="是否启用" name="is_forbidden" rules={[{ required: true, message: '必须选择是否启用' }]}>
                    <Select style={{ width: 160 }} placeholder="请选择是否启用">
                        {myStatus.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 6, span: 10 }}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>
    </div>)
}